import type { ReactNode } from 'react';
import { Suspense } from 'react';

import Box from '@mui/material/Box';
import { useLocation } from 'react-router';

import Loader from '@/components/Loader';

const SuspenseWrapper = ({ children, customKey }: { children: ReactNode; customKey?: string }) => {
  const { pathname } = useLocation();

  return (
    <Suspense
      key={customKey ?? pathname}
      fallback={
        <Box
          sx={{
            height: '100dvh'
          }}
        >
          <Loader />
        </Box>
      }
    >
      {children}
    </Suspense>
  );
};

export const withSuspense = (element: ReactNode, customKey?: string) => (
  <SuspenseWrapper customKey={customKey}>{element}</SuspenseWrapper>
);
